import { useState } from 'react'

import Paper from '@mui/material/Paper'

import StyledTable from '@components/StyledTable'

import { useAutosuggest } from '../../../autosuggest/hooks/useAutosuggest'
import { ENTITIES } from '../../../entity'
import { Page } from '../../../theme/components/Page'
import { PageSection } from '../../../theme/components/PageSection'
import { useHoofdnetValuelists } from '../../../valuelists/hooks/useHoofdnetValuelists'
import { HoofdnetOpdrachtenFilters } from '../components/HoofdnetOpdrachtenFilters'
import { HoofdnetOpdrachtenTableRow } from '../components/HoofdnetOpdrachtenTableRow'
import { useHoofdnetOpdrachtenSearch } from '../hooks/useHoofdnetOpdrachtenSearch'

const headerCells = [
  { id: 'opdrachtId', numeric: true, label: 'Opdracht id', sort: false },
  { id: 'versieNummer', label: 'Versienummer', sort: false, fixed: 50 },
  { id: 'details.discipline', label: 'Discipline', sort: false, fixed: 50 },
  { id: 'opdrachtgever', numeric: true, label: 'Opdrachtgever', sort: false },
  { id: 'opdrachtnemer', numeric: true, label: 'Opdrachtnemer', sort: false },
  {
    id: 'created',
    numeric: false,
    label: 'Creatiedatum',
    sort: true,
  },
  { id: 'changed', numeric: false, label: 'Mutatiedatum', sort: true },
  { id: 'status', label: 'Status', sort: false },
  { id: 'details', label: 'Details', sort: false, fixed: 100 },
] as const

export const HoofdnetOpdrachten = () => {
  const { data: hoofdnetValuelists } = useHoofdnetValuelists()
  const {
    data: { items: opdrachten, count, skip, limit },
    isLoading,
    isError,
    initialFilters,
    onChangeFilters,
    onChangeSort,
    onChangePage,
    filters,
    sort,
    onReset,
    onRefresh,
  } = useHoofdnetOpdrachtenSearch()
  const [searchText, setSearchText] = useState('')
  const { data: options } = useAutosuggest({
    text: searchText,
    entityType: ENTITIES.HOOFDNET_OPDRACHT,
  })

  return (
    <Page
      title={['Opdrachten', 'Hoofdnet']}
      breadcrumbs={[
        { label: 'Hoofdnet', href: '/home', tooltip: 'CAPO home' },
        { label: 'Opdrachten' },
      ]}
      fillScreen
    >
      <PageSection
        id="hoofdnetopdrachten"
        heading="Overzicht van alle hoofdnet opdrachten"
      />

      <Paper>
        <div>
          <HoofdnetOpdrachtenFilters
            onChange={onChangeFilters}
            filters={filters}
            initialFilters={initialFilters}
            onSearchChange={(search: string) => setSearchText(search)}
            options={options}
            onRefresh={onRefresh}
            onReset={onReset}
            filterOptions={hoofdnetValuelists}
          />

          <StyledTable
            onChangeSort={onChangeSort}
            onChangePage={onChangePage}
            headerCells={headerCells}
            sort={sort}
            stats={{ count, skip, limit }}
            loading={isLoading}
            isError={isError}
          >
            {opdrachten.map((opdracht) => (
              <HoofdnetOpdrachtenTableRow
                key={opdracht.opdrachtId}
                opdracht={opdracht}
              />
            ))}
          </StyledTable>
        </div>
      </Paper>
    </Page>
  )
}
